import { configureStore } from "@reduxjs/toolkit";
import { reducers as sharedReducers } from "@hydrologiq/shared/state/store";

// Create the Redux store for alerts section
const store = configureStore({
  reducer: {
    // Add reducers as needed
    ...sharedReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
